const personaStyles = (theme) => ({
  personaVerificationDiv: {
    // border: "3px solid red",
    height: "900px",
    width: "350px",
    justifyContent: "center",
    alignSelf: "center",

    [theme.breakpoints.up("sm")]: {
      width: "550px",
    },

    "& iframe": {
      height: "900px",
      width: "100%",
    },
  },
});

export default personaStyles;
